export default function UseCases() {
  const cases = [
    {
      image: 'https://www.inforesta.com/lp2/image/194dded3535e27dcf3facea9372fc7b7.jpg',
      role: '医師',
      specialty: '',
      quote: '自分で探すより早く見つかって助かった',
      detail: '学会発表の準備で時間がない中、必要な論文を迅速に入手できました。概要も付けていただき、内容の把握が非常にスムーズでした。'
    },
    {
      image: 'https://www.inforesta.com/lp2/image/6990e931871aeeb5b7c1f0f8248998a1.jpg',
      role: '病院総務部　ご担当者様',
      specialty: '',
      quote: 'コストが大幅に抑えられました',
      detail: '利用頻度の高い雑誌だけを定期購読に絞ることで、管理物が減り、コストも大幅に抑えられました。'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            具体的な活用事例
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600">
            実際にご利用いただいている医療従事者の声
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 sm:gap-8">
          {cases.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="p-5 sm:p-6 md:p-8">
                <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                  <img
                    alt={item.role}
                    className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover border-4 border-teal-100 flex-shrink-0"
                    src={item.image}
                  />
                  <div className="min-w-0">
                    <div className="text-xs sm:text-sm text-teal-600 font-semibold mb-1">
                      {item.role}
                    </div>
                  </div>
                </div>

                <div className="flex gap-1 mb-3 sm:mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-base sm:text-lg"></i>
                  ))}
                </div>

                <div className="bg-teal-50 rounded-xl p-3 sm:p-4 mb-3 sm:mb-4">
                  <i className="ri-double-quotes-l text-teal-600 text-xl sm:text-2xl mb-2 block"></i>
                  <p className="text-sm sm:text-base md:text-lg text-gray-900 font-semibold leading-relaxed">
                    {item.quote}
                  </p>
                </div>

                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  {item.detail}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
